import React, { forwardRef } from 'react';
import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';
function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  error?: string;
  helperText?: string;
  options: {
    label: string;
    value: string;
  }[];
}
export const Select = forwardRef<HTMLSelectElement, SelectProps>(({
  className,
  label,
  error,
  helperText,
  options,
  ...props
}, ref) => {
  return <div className="w-full" data-id="element-481">
        {label && <label className="block text-sm font-medium text-navy mb-1.5" data-id="element-482">
            {label} {props.required && <span className="text-red-500" data-id="element-483">*</span>}
          </label>}
        <select className={cn('flex h-11 w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm ring-offset-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-navy focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50', error && 'border-red-500 focus-visible:ring-red-500', className)} ref={ref} {...props} data-id="element-484">
          <option value="" disabled selected data-id="element-485">
            Select an option
          </option>
          {options.map(opt => <option key={opt.value} value={opt.value} data-id="element-486">
              {opt.label}
            </option>)}
        </select>
        {helperText && !error && <p className="mt-1 text-xs text-gray-500" data-id="element-487">{helperText}</p>}
        {error && <p className="mt-1 text-xs text-red-500" data-id="element-488">{error}</p>}
      </div>;
});
Select.displayName = 'Select';